import type { App } from "vue";
import store from "@/store";

export function installLegacyStoreBridge(app: App) {
  app.config.globalProperties.$store = {
    direct: store,
  };
}
